module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "padded"
  }, [_c('h2', {
    staticClass: "text-warning",
    staticStyle: {
      "padding-top": "5vh"
    }
  }, [_vm._v("Coming Soon")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-17dfece3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/ComingSoon.vue
// module id = 1344
// module chunks = 0